import { makeStyles } from '@material-ui/styles'

const useStyles = makeStyles((theme) => ({
  root: {
    padding: theme.spacing(3),
  },
  container: {
    padding: theme.spacing(2),
  },
  gridTitle: {
    borderBottom: 'thin solid #DDD',
  },
  carregando: {
    margin: '0 auto',
  }
}))

export default useStyles
